/**
 * Mirrors the engine's dynamic-resolution behavior (novorender recalcBaseRenderResolution
 * + DRS tier multipliers [0.4, 0.6, 1]): for tier < 2 the base render resolution is
 * recomputed from canvas size and capped at 0.5; the DRS floor is base * 0.4.
 */
export function computeEngineResolutionFloor(
    canvas: HTMLCanvasElement,
    tier: number,
    profileRenderResolution: number,
): number | undefined {
    const drsLowestStep = 0.4;
    let base = profileRenderResolution;

    if (tier < 2) {
        const sizeBudget = tier === 0 ? 2000 : 4000;
        const { width, height } = canvas.getBoundingClientRect();
        if (width + height > 0) {
            base = Math.min(0.5, sizeBudget / (width + height) / 2 / devicePixelRatio);
        } else {
            base = Math.min(0.5, base);
        }
    }

    return base * drsLowestStep;
}
